import { render } from "./center-offers-banner.vue?vue&type=template&id=79e8fb4b&scoped=true"
import script from "./center-offers-banner.vue?vue&type=script&lang=js"
export * from "./center-offers-banner.vue?vue&type=script&lang=js"

import "./center-offers-banner.vue?vue&type=style&index=0&id=79e8fb4b&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79e8fb4b"]])

export default __exports__